import styles from './RetroGrid.module.css';

interface RetroGridProps {
  className?: string;
}

export function RetroGrid({ className }: RetroGridProps) {
  return (
    <div className={`${styles.container} ${className || ''}`}>
      {/* Starfield background */}
      <div className={styles.stars} />
      <div className={styles.stars2} />
      <div className={styles.stars3} />

      {/* Perspective Grid Floor */}
      <div className={styles.gridContainer}>
        <div className={styles.grid}>
          <div className={styles.gridLines} />
        </div>
      </div>

      {/* Horizon glow */}
      <div className={styles.horizonGlow} />

      {/* Scanline effect */}
      <div className={styles.scanlines} />
    </div>
  );
}
